import request from '@/utils/request'


// 查询销售订单列表
export function listSell(data) {
  return request({
    url: '/biz/admin/order/sell/list',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}



// 查询销售订单分页
export function pageSell(data) {
  return request({
    url: '/biz/admin/order/sell/page',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

// 查询销售订单分页
export function pageUniformSell(data) {
  return request({
    url: '/biz/admin/order/sell/uniform/page',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}


// 查询销售订单详细
export function getSell(data) {
  return request({
    url: '/biz/admin/order/sell/mall/detail',
    method: 'post',
    data: data
  })
}

export function getSellScore(data) {
  return request({
    url: '/biz/admin/order/sell/score/detail',
    method: 'post',
    data: data
  })
}

export function getSellUniform(data) {
  return request({
    url: '/biz/admin/order/sell/uniform/detail',
    method: 'post',
    data: data
  })
}

export function editSellSku(data) {
  return request({
    url: '/biz/admin/order/sell/edit/sku',
    method: 'post',
    data: data
  })
}

export function cancelSell(data) {
  return request({
    url: '/biz/admin/order/sell/cancel',
    method: 'post',
    data: data
  })
}

export function receiptSell(data) {
  return request({
    url: '/biz/admin/order/sell/receipt',
    method: 'post',
    data: data
  })
}


export function deliverySell (data) {
  return request({
    url: '/biz/admin/order/sell/delivery',
    method: 'post',
    data: data
  })
}

export function carPostSell (data) {
  return request({
    url: '/biz/admin/order/sell/car/post',
    method: 'post',
    data: data
  })
}

export function prodSell(data) {
  return request({
    url: '/biz/admin/order/sell/prod',
    method: 'post',
    data: data
  })
}

export function prodFinishSell(data) {
  return request({
    url: '/biz/admin/order/sell/prod/finish',
    method: 'post',
    data: data
  })
}





export function deliverySellUpdate (data) {
  return request({
    url: '/biz/admin/order/delivery/update',
    method: 'post',
    data: data
  })
}


// 导入待发货
export function importData (data) {
  return request({
    url: '/biz/admin/order/sell/delivery/import',
    method: 'post',
    data: data
  })
}

//物流信息
export function logistics(data) {
  return request({
    url: '/biz/admin/order/sell/logistics',
    method: 'post',
    data: data
  })
}

export function changeAddress(data) {
  return request({
    url: '/biz/admin/order/sell/change/address',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

export function updateAddress(data) {
  return request({
    url: '/biz/admin/order/sell/update/address',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}

export function userAddress(data) {
  return request({
    url: '/biz/admin/user/address/page',
    headers:{"repeatSubmit": false},
    method: 'post',
    data: data
  })
}



export function sellPay(data) {
  return request({
    url: '/biz/admin/order/sell/pay',
    method: 'post',
    data: data
  })
}

export function sellCustomProcess(data) {
  return request({
    url: '/biz/admin/order/sell/custom/process',
    method: 'post',
    data: data
  })
}


export function amountPreview(data) {
  return request({
    url: '/biz/admin/order/sell/amount/preview',
    method: 'post',
    data: data
  })
}

export function amountChange(data) {
  return request({
    url: '/biz/admin/order/sell/amount/change',
    method: 'post',
    data: data
  })
}

export function updateRemark(data) {
  return request({
    url: '/biz/admin/order/sell/update/remark',
    method: 'post',
    data: data
  })
}
